import {
  Button,
  ButtonGroup,
  Col,
  Container,
  Form,
  Row,
  Spinner,
} from "react-bootstrap";
import React, { useState } from "react";
import toast from "react-hot-toast";
import Packages from "./Packages";
import Numbers from "./Numbers";
import axiosInstance from "../../api/axiosInstance";

const CreateUser = ({ handleClose, setIsNewUserAdded }) => {
  const [activeButton, setActiveButton] = useState("Packages");
  const [formData, setFormData] = useState({
    assignNumber: [],
    email: "",
    firstName: "",
    lastName: "",
    password: "",
    paymentPackage: {
      packageName: "BasicUK",
      price: "5",
      quantity: "1",
    },
    paymentStatus: true,
    phone: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axiosInstance.post("/auth/signup", formData);

      const { data } = response;

      if (data) {
        handleClose();
        setIsNewUserAdded(true);

        toast.success(data.message);

        data.twilioResponse.forEach((res) => {
          if (res.status === "rejected")
            toast.error(`${res.phoneNumber} ${res.reason}`);
        });
      }
    } catch (error) {
      if (error.response) toast.error(error.response.data.message);

      console.error("🚀 -> handleSubmit -> error:", error);
    } finally {
      setLoading(false);
      setIsNewUserAdded(false);
    }
  };

  return (
    <>
      <Container>
        <Row className="justify-content-md-center">
          <Col md={6}>
            <h2 className="text-center mb-4">Create New User</h2>
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3" controlId="firstName">
                <Form.Label>First Name</Form.Label>
                <Form.Control
                  name="firstName"
                  onChange={handleChange}
                  placeholder="Enter first name"
                  required
                  type="text"
                  value={formData.firstName}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="lastName">
                <Form.Label>Last Name</Form.Label>
                <Form.Control
                  name="lastName"
                  onChange={handleChange}
                  placeholder="Enter last name"
                  required
                  type="text"
                  value={formData.lastName}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="email">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  name="email"
                  onChange={handleChange}
                  placeholder="Enter email"
                  required
                  type="email"
                  value={formData.email}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="password">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  name="password"
                  onChange={handleChange}
                  placeholder="Enter password"
                  required
                  type="password"
                  value={formData.password}
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="phone">
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  name="phone"
                  onChange={handleChange}
                  placeholder="Enter phone number"
                  required
                  type="tel"
                  value={formData.phone}
                />
              </Form.Group>
              <ButtonGroup className="mb-3 w-100">
                <Button
                  className={activeButton === "Packages" && "primaryBtn"}
                  onClick={() => setActiveButton("Packages")}
                  variant={activeButton !== "Packages" && "secondary"}
                >
                  Packages
                </Button>
                <Button
                  className={activeButton === "Numbers" && "primaryBtn"}
                  onClick={() => setActiveButton("Numbers")}
                  variant={activeButton !== "Numbers" && "secondary"}
                >
                  Numbers
                </Button>
              </ButtonGroup>
              {activeButton === "Packages" ? (
                <Packages formData={formData} setFormData={setFormData} />
              ) : (
                <Numbers formData={formData} setFormData={setFormData} />
              )}
              <Row className="mt-3">
                <Col>
                  <Button
                    className="w-100"
                    disabled={loading}
                    onClick={handleClose}
                    type="button"
                    variant="danger"
                  >
                    Cancel
                  </Button>
                </Col>
                <Col>
                  <Button
                    className="w-100"
                    disabled={loading}
                    type="submit"
                    variant="success"
                  >
                    {loading ? "Creating..." : "Create"}
                  </Button>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Container>

      {loading && (
        <div
          style={{
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.75)",
            display: "flex",
            height: "100vh",
            justifyContent: "center",
            left: 0,
            position: "fixed",
            top: 0,
            width: "100vw",
            zIndex: 1000,
          }}
        >
          <Spinner
            animation="border"
            style={{
              borderWidth: 8,
              height: 100,
              width: 100,
            }}
            variant="light"
          />
        </div>
      )}
    </>
  );
};

export default CreateUser;
